import { render } from "./TrainingProgramAccordionComponent.vue?vue&type=template&id=38ebf812&scoped=true"
import script from "./TrainingProgramAccordionComponent.vue?vue&type=script&lang=js"
export * from "./TrainingProgramAccordionComponent.vue?vue&type=script&lang=js"

import "./TrainingProgramAccordionComponent.vue?vue&type=style&index=0&id=38ebf812&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ebf812"]])

export default __exports__